
















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import CONFIG from "@/common/config";
import fetch from "@/common/api/fetch";
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import { ShareObjectInterface, SignatureData, AxiosPromiseData } from "@/common/interface";

import ActivitySection from "@/components/common/index/ActivitySection.vue";

@Component({
  components: {
    "activity-section": ActivitySection
  }
})
export default class SolitaireingListModal extends Vue {
  @Prop() show!: boolean;
  @Getter("solitaireingList") solitaireingList!: Array<object>;
  @Getter("title") title!: string;
  @Getter("section") section!: any;
  @Getter("coverTiny") coverTiny!: string;
  @Getter("signature") signature!: SignatureData;

  @Action("changeSolitaireingList") changeSolitaireingList!: Function;

  resultList: Array<Object> = [];
  pageNo: number = 0;
  pageSize: number = 16;
  hasNext: boolean = true;

  handleCloseModal() {
    this.$emit("hide");
  }

  mounted() {
    this.getSolitaireingList();
  }
  getSolitaireingList() {
    const params = {
      activityId: getUrlParam("broadcastId"),
      pageNo: this.pageNo,
      pageSize: this.pageSize,
    };
    return fetch.newpost("anon/solitaire/getAllApplySignIns", params)
      .then((res: AxiosPromiseData) => {
        const { records, pages } = res.result;
        const solitaireingList = this.solitaireingList.concat(records)

        this.hasNext = this.pageNo < Number(pages) - 1;
        if (this.pageNo > 0) {
          this.changeSolitaireingList(solitaireingList);
        }
      });
  }

  getMore() {
    this.pageNo = this.pageNo + 1;
    this.getSolitaireingList();
  }
}
